const productPurposeHeaders = {
  en: "WHY?",
  fr: "POURQUOI?",
  nl: "WAAROM?",
  de: "WARUM?",
  pl: "DLACZEGO?",
};

const certificationHeaders = {
  en: "KOT Certificate",
  pl: "Krajowa Ocena Techniczna",
};

const specificationHeaders = {
  en: "SPECIFICATIONS",
  fr: "SPECIFICATIONS",
  nl: "SPECIFICATIES",
  de: "SPECIFICATIONEN",
  pl: "SPECYFIKACJA",
};

function formatDetail(string) {
  return string
    .replace("\r", "")
    .replace("\n", "")
    .split("•")
    .filter((str) => str.length);
}

export default function (category, language = "en") {
  if (!category) return;

  const productPurpose = { ...category }.www?.find((info) =>
    Object.values(info.header).includes(
      productPurposeHeaders[language].replace(" ", "")
    )
  );

  if (productPurpose) {
    for (const key in productPurpose.text) {
      if (typeof productPurpose?.text[key] === "string") {
        productPurpose.text[key] = formatDetail(productPurpose.text[key]);
      }
    }
  }

  const specifications = { ...category }.www?.find((info) =>
    Object.values(info.header).includes(specificationHeaders[language])
  );

  if (specifications) {
    for (const key in specifications.text) {
      if (typeof specifications?.text[key] === "string") {
        specifications.text[key] = formatDetail(specifications.text[key]);
      }
    }
  }

  const productCertification = { ...category }.www?.find(
    (info) =>
      Object.values(info.header).includes(certificationHeaders[language]) ||
      Object.values(certificationHeaders).some((header) =>
        Object.values(info.header).includes(header)
      )
  );

  return {
    productPurpose,
    productCertification,
    specifications,
  };
}
